import React from 'react';
import { NOKIA_PURE_HEADLINE } from '@nokia-csf-uxr/freeform-design-tokens/tokens/fontFamily';
import { getContext } from 'common';
import Typography, { TypographyProps } from 'components/Typography';
import Tokens from '@nokia-csf-uxr/freeform-design-tokens';

const {
  COLORS,
  LINE_HEIGHT,
  FONT_SIZE,
  SPACING
} = Tokens;

const ELEMENT_TYPE = 'span';

const DEFAULT_STYLE = style => ({
  fontFamily: NOKIA_PURE_HEADLINE,
  fontSize: FONT_SIZE.FONT_SIZE_12,
  lineHeight: `${LINE_HEIGHT.LINE_HEIGHT_NONE}rem`,
  color: COLORS.NEUTRAL_GREY_300,
  marginBottom: SPACING.SPACING_4,
  ...style
});

export interface LabelContentProps extends TypographyProps {
  children: React.ReactNode | string;
  maxLines?: number;
  required?: boolean;
  requiredSymbol?: string;
  style?: React.CSSProperties;
}

const LabelContent = React.forwardRef<HTMLElement, LabelContentProps>((props: LabelContentProps, ref) => getContext(({ RTL }) => {
  const {
    style,
    children,
    required,
    requiredSymbol,
    ...otherProps
  } = props;

  const requiredSymbolStyle = RTL ? {
    style: {
      padding: '0 0 0 0.625rem',
    },
    afterContent: requiredSymbol,
    beforeContent: undefined
  } : {
    style: {
      padding: '0 0.625rem 0 0',
    },
    beforeContent: requiredSymbol,
    afterContent: undefined
  };

  const resolvedStyle = required
    ? requiredSymbolStyle
    : {
      style: undefined,
      beforeContent: undefined,
      afterContent: undefined,
    };

  const typographyProps = {
    ...otherProps,
    as: ELEMENT_TYPE,
    style: {
      ...resolvedStyle.style,
      ...DEFAULT_STYLE(style)
    },
    beforeContent: resolvedStyle.beforeContent,
    afterContent: resolvedStyle.afterContent,
  };
  return (
    <Typography
      ref={ref}
      {...typographyProps}
    >
      {children}
    </Typography>
  );
}));

LabelContent.defaultProps = {
  maxLines: 1,
  required: false,
  requiredSymbol: '*',
  style: {}
};

LabelContent.displayName = 'LabelContent';

export default LabelContent;
